import { CrownMark } from "./CrownMark";

export const PostBadge = ({ post, className = "" }) => {
  if (post.theme === "electric")
    return (
      <span
        data-testid="post-badge-electric"
        className={`inline-flex items-center gap-1.5 rounded-sm bg-electric px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-widest text-obsidian ring-2 ring-gold shadow-[0_0_26px_rgba(34,211,238,0.55)] ${className}`}
      >
        <CrownMark className="h-3" animate={false} />
        {post.category}
      </span>
    );
  if (post.theme === "royal")
    return (
      <span
        data-testid="post-badge-royal"
        className={`inline-flex items-center gap-1.5 rounded-sm bg-royal px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-widest text-white ring-1 ring-neon/70 shadow-[0_0_26px_rgba(31,79,216,0.55)] ${className}`}
      >
        <CrownMark className="h-3" animate={false} />
        {post.category}
      </span>
    );
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-sm bg-gold px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-widest text-obsidian ${className}`}>
      <CrownMark className="h-3" animate={false} variant="neon" stroke="#0A0A0A" />
      {post.category}
    </span>
  );
};

export const RoyalRule = ({ label = "Royal Blue Series" }) => (
  <div className="mt-6 flex items-center gap-4" data-testid="royal-rule">
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-gold/60 to-gold" />
    <CrownMark className="h-4" animate={false} />
    <span className="font-mono text-[10px] uppercase tracking-[0.4em] text-gold">{label}</span>
    <CrownMark className="h-4" animate={false} />
    <span className="h-px flex-1 bg-gradient-to-l from-transparent via-gold/60 to-gold" />
  </div>
);
